import React, { useState, useRef, useEffect, useContext } from "react";
import { Form, Label, Input } from "reactstrap";
import JoditEditor from "jodit-react";
import { ApiContext } from "../apiContext";
import EditorConfig from "../../helper/JoditEditor";

const AddForm = ({
  handleSubmit,
  formError,
  getInputValue,
  handleInputChange,
  contentDataChanged,
  handleClear,
  modalData,
  addCase,
  setModalData,
  setCase,
  closeModal,
  careerCategory,
}) => {
  const editor = useRef(null);
  const [editorConfig, setEditorConfig] = useState(null);
  useEffect(() => {
    // Initialize Jodit editor
    setEditorConfig(EditorConfig);
  }, []);
  const { error } = useContext(ApiContext);
  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="row edit-form">
          <div className="my-3 col-md-6">
            <Label for="title">Title / Role</Label>
            <Input
              type="text"
              id="title"
              name="title"
              placeholder="Title"
              required
              value={getInputValue("title")}
              onChange={(event) => handleInputChange(event, "title")}
            />
            <span className="non-valid">{formError.title}</span>
          </div>

          <div className="my-3 col-md-6">
            <Label for="url">Location</Label>
            <Input
              type="text"
              id="location"
              placeholder="Location"
              value={getInputValue("location")}
              onChange={(event) => handleInputChange(event, "location")}
            />
            <span className="non-valid">{formError.location}</span>
          </div>

          <div className="my-3 col-md-6">
            <Label for="skills">Skills</Label>
            <Input
              type="text"
              id="skills"
              name="skills"
              placeholder="Skills"
              required
              value={getInputValue("skills")}
              onChange={(event) => handleInputChange(event, "skills")}
            />
          </div>

          <div className="my-3 col-md-6">
            <Label for="experience">Experience Requirement</Label>
            <Input
              type="text"
              id="experience"
              placeholder="Experience"
              value={getInputValue("experience")}
              onChange={(event) => handleInputChange(event, "experience")}
            />
            <span className="non-valid">{formError.experience}</span>
          </div>
                    <div className="my-3 col-md-12">
            <Label for="category">Category</Label>
            <select
              id="category"
              name="categoryid"
              className="select-list"
              onChange={(event) => handleInputChange(event, "category")}
              value={getInputValue("category")}
            >
              <option value="">-- Select Category --</option>
              {careerCategory &&
                careerCategory
                  .filter((option) => option.Status === true)
                  .map((option) => (
                    <option key={option.Code} value={option.Code}>
                      {option.Name}
                    </option>
                  ))}
            </select>
            <span className="non-valid">{formError.category}</span>
          </div>
          <div className="my-3 col-md-12">
            <Label for="author-bio">Responsibilities Description</Label>
            <JoditEditor
              ref={editor}
              config={editorConfig}
              value={modalData?.responsibilities || ""}
              onChange={(event) => contentDataChanged(event, "responsibilities")}
            />
          </div>
          <div className="my-3 col-md-12">
            <Label for="author-bio">Knowledgeand Skills Description</Label>
            <JoditEditor
              ref={editor}
              config={editorConfig}
              value={modalData?.knowledgeandskills || ""}
              onChange={(event) => contentDataChanged(event, "knowledgeandskills")}
            />
          </div>
          <div className="my-3 col-md-12">
            <Label for="author-bio">Education And Experience Description</Label>
            <JoditEditor
              ref={editor}
              config={editorConfig}
              value={modalData?.educationandexperience || ""}
              onChange={(event) => contentDataChanged(event, "educationandexperience")}
            />
          </div>
          <div className="my-3 col-md-12">
            <Label for="author-bio">Other Description</Label>
            <JoditEditor
              ref={editor}
              config={editorConfig}
              value={modalData?.description || ""}
              onChange={(event) => contentDataChanged(event, "description")}
            />
          </div>
          {/* <div className="my-3 col-md-6">
            <Label for="imagefile">
              Select Blog Image (Upload only images up to 100kb)
            </Label>
            <div className="file-field">
              <div className="btn helensys-theme-btn btn-sm ml-0">
                <span>Choose File</span>
                <Input
                  id="documentuplad"
                  name="imagefile"
                  type="file"
                  onChange={(event) =>
                    handleImageUpload(event, "thumbnail_image")
                  }
                  accept="image/gif, image/jpeg, image/png, image/webp*"
                  encType="multipart/form-data"
                />
              </div>
              <div className="file-path-wrapper">
                <Input
                  className="file-path validate"
                  value={
                    modalData
                      ? modalData.thumbnail_image_name
                      : addCase.thumbnail_image_name
                  }
                  type="text"
                  placeholder=""
                  onChange={(event) =>
                    handleInputChange(event, "thumbnail_image_name")
                  }
                />
              </div>
            </div>
          </div> */}
          {/* <div className="my-3 col-md-6">
            <Label for="imagefile">
              Select Case Studies Pdf (Upload only Pdf upto 5mb)
            </Label>
            <div className="file-field">
              <div className="btn helensys-theme-btn btn-sm ml-0">
                <span>Choose File</span>
                <Input
                  id="documentuplad"
                  name="pdffile"
                  type="file"
                  onChange={(event) =>
                    handleImageUpload(event, "thumbnail_pdf")
                  }
                  accept="image/pdf*"
                  encType="multipart/form-data"
                />
              </div>
              <div className="file-path-wrapper">
                <Input
                  className="file-path validate"
                  value={
                    modalData
                      ? modalData.thumbnail_pdf_name
                      : addCase.thumbnail_pdf_name
                  }
                  type="text"
                  placeholder=""
                  onChange={(event) =>
                    handleInputChange(event, "thumbnail_pdf_name")
                  }
                />
              </div>
            </div>
          </div> */}
          {/* <div className="my-3 email">
            <Label for="email-confi">Email Configuration</Label>
            <Input
              type="checkbox"
              id="email-confi"
              name="email-confi"
              value="email-confi"
              checked={
                modalData?.emailconfigurationflag ||
                addCase?.emailconfigurationflag
              }
              onChange={() => {
                if (modalData) {
                  setModalData((prevModalData) => ({
                    ...prevModalData,
                    emailconfigurationflag:
                      !prevModalData.emailconfigurationflag,
                  }));
                } else {
                  setCase((prevAddCase) => ({
                    ...prevAddCase,
                    emailconfigurationflag: !prevAddCase.emailconfigurationflag,
                  }));
                }
              }}
            />
          </div> */}
          {/* Render email-show block */}
          {/* {(modalData?.emailconfigurationflag ||
            addCase?.emailconfigurationflag) && (
            <div className="email-show">
              <div className="my-3 col-md-12">
                <Label for="url">Email send schedule in days</Label>
                <Input
                  type="number"
                  id="alttext"
                  name="email schedule"
                  value={getInputValue("sendemaildays")}
                  onChange={(event) =>
                    handleInputChange(event, "sendemaildays")
                  }
                />
              </div>
              <div className="my-3 col-md-12">
                <Label for="url">Email Template</Label>
                <JoditEditor
                  ref={editor}
                  value={modalData?.emailtemplate || ""}
                  onChange={(newContent) =>
                    handleInputChange(
                      { target: { value: newContent } },
                      "emailtemplate"
                    )
                  }
                />
              </div>
            </div>
          )} */}
          <div className="my-3 col-md-6">
            <Label for="status">Status</Label>
            <div className="toggle">
              <span>Inactive</span>
              <label
                className={`switch ${
                  (modalData && modalData.status) || addCase.status
                    ? "true"
                    : ""
                }`}
              >
                <Input
                  type="checkbox"
                  checked={modalData && modalData.status}
                  onChange={() => {
                    if (modalData) {
                      setModalData((prevModalData) => ({
                        ...prevModalData,
                        status: !prevModalData.status,
                      }));
                    } else {
                      setCase((prevAddCase) => ({
                        ...prevAddCase,
                        status: !prevAddCase.status,
                      }));
                    }
                  }}
                />
                <span className="slider round"></span>
              </label>
              <span>Active</span>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-warning ms-2"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary ms-2"
            >
              Submit
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};
export default AddForm;
